import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { getRatingsRowCount } from 'app/webview/pages/stats_profile/lib/utils'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const RatingsGridY = () => {
  const theme = useStatsTheme((s) => s.theme)
  const stats = useStats((s) => s.stats)
  const topRating = stats?.ratings?.top?.count || 0
  const rowCount = getRatingsRowCount(topRating)
  const yAxisIncrement = topRating >= 30 ? 10 : 5
  const maxCount = 50

  return (
    <FlexBox
      className={css`
        flex-shrink: 1;
        opacity: 0.5;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      `}
      flexDirection="column-reverse"
      alignItems="flex-end"
    >
      {Array.from({ length: rowCount }).map((_, i) => (
        <FlexBox
          key={i}
          className={css`
            flex-grow: 1;
            width: 100%;
            border-bottom: ${i === 0 ? 'none' : '1px dashed'};
            border-color: ${theme.colors.section.chart.lines};
            position: relative;
          `}
        >
          <FlexBox
            className={css`
              align-self: flex-start;
              width: 10px;
              position: absolute;
              bottom: -1px;
              right: -14px;
            `}
            alignItems="center"
          >
            <span
              className={css`
                width: 2px;
                height: 1px;
                background-color: ${theme.colors.section.textSecondary};
                flex-shrink: 0;
              `}
            />
            {i % yAxisIncrement === 0 ? (
              <Text
                className={css`
                  position: absolute;
                  left: 4px;
                `}
                type="label"
                sizing="S"
                weight="500"
                color={theme.colors.section.textSecondary}
              >
                {i.toString()}
              </Text>
            ) : null}
          </FlexBox>
        </FlexBox>
      ))}
      <FlexBox
        className={css`
          align-self: flex-start;
          width: 10px;
          position: absolute;
          top: -1px;
          right: -14px;
        `}
        alignItems="center"
      >
        <span
          className={css`
            width: 2px;
            height: 1px;
            background-color: ${theme.colors.section.textSecondary};
            flex-shrink: 0;
          `}
        />
        {rowCount % yAxisIncrement === 0 || rowCount === maxCount ? (
          <Text
            className={css`
              position: absolute;
              left: 4px;
            `}
            type="label"
            sizing="S"
            weight="500"
            color={theme.colors.section.textSecondary}
          >
            {rowCount}
            {rowCount === maxCount ? '+' : ''}
          </Text>
        ) : null}
      </FlexBox>
    </FlexBox>
  )
}
